var ContentServerClient = require("./../ContentServerClient.js");

class ImportUtil {

    constructor(){}
    
    createLibrary(handleError, source, data, resource = {}){
        let defaults = {"name": "Unnamed", "description":"", "tags": [], "assets": []};
        let resouce =  Object.assign(defaults, resource);
        return ContentServerClient.createResource(handleError, resouce, "libraries")
                .then(info => {
                    if(source === 'url'){ return this.getUrl(handleError, info.id, data) }
                    if(source === 'file'){ return this.getFile(handleError, info.id, data) }
                })
    }

    // regarding many functions in this page... there is no reason to have a globally accessible
    // function where all it does is call another globally accessible function!
    // lots of these should be removed.
    getUrl(handleError, id, data, newfile = true){
        return ContentServerClient.importEagleLibraryURL(handleError, id, data, !newfile)
    }

    getLibraryDownloadPath(id, original){
        return ContentServerClient.getLibraryDownloadPath(id, original);
    }

    getFile(handleError, id, data, newfile = true) {
        return ContentServerClient.importEagleLibraryFile(handleError, id, data, !newfile)
    }

    getStatus(handleError, id, handleProgress = false){
        return new Promise((resolve, reject) => this.getAssetImportStatus(handleError, {resolve, reject, id, handleProgress}));
    }

    pollImportStatus(handleError, {resolve, reject, id, handleProgress}) {
        setTimeout(() => this.getAssetImportStatus(handleError, {resolve, reject, id, handleProgress}), 10000);
    }

    getAssetImportStatus(handleError, {resolve, reject, id, handleProgress}) {
        ContentServerClient.importStatus(handleError, id)
            .then(response => {
                if(response.status === "importing") {
                    if(handleProgress){this.formatPercent({response, handleProgress})}
                    this.pollImportStatus(handleError, {resolve, reject, id, handleProgress})
                }else if(response.status === "done") {
                    resolve(this.getMessage(response, id))
                }
                else if(response.status === "failed") {
                    reject(response)
                }
            })
            .catch(info => reject(info));
    }

    formatPercent({response: {progress, total}, handleProgress}){
        handleProgress({show: true, percent: Math.round(progress / Math.abs(total) * 100)})
    }

    hasVendorImport (savePoints) {
        return savePoints && (savePoints.filter(e => e.source && e.source.type === "vendorLibrary").length > 0);
    }

    getVendorStatus(handleError, id){
        return new Promise((resolve, reject) => this.getVendorAssetImportStatus(handleError, resolve, reject, id));
    }

    pollVendorImportStatus(handleError, resolve, reject, id) {
        setTimeout(() => this.getVendorAssetImportStatus(handleError, resolve, reject, id), 10000);
    }

    getVendorAssetImportStatus(handleError, resolve, reject, id) {
        ContentServerClient.vendorImportStatus(handleError, id)
            .then((response) => {
                if(response.status === "importing") {
                    this.pollVendorImportStatus(handleError, resolve, reject, id);
                }else{
                    resolve(this.getMessage(response, id));
                }
            })
            .catch(info => reject(info));
    }

    getMessage(response, id){
        switch (true) {
            case response && response.status === "done": 
                return({type: "done"});
            case response && response.status === "failed" && response.status_details === "process timed out":
                return({type: "bad", info: `It looks like your library is too large to upload.  Please try splitting it into multiple libraries before reimporting.`});
            default:
                return({type: "bad", info: `There was a problem uploading your library.  If this problem persists, please contact support with library reference ID ${id}.`});
        }
    }

    createResource3D(handleError, fileData, onProgress, resource = {}){
        let assetName = fileData.name.split('.')[0];
        let basicResource = {
            "name": assetName,
            "description": "A 3d model used by a Circuits Package",
            "tags": [ "3d Model", "Electronic" ],
            "score": 0,
            "private": true
        };
        var newId = 0;
        
        onProgress(`Reading File: ${assetName}`);

        return ContentServerClient.createResource(handleError, Object.assign(basicResource, resource), "3dmodels")
                .then(info => {
                    newId = info.id;
                    let formData = new FormData();
                    formData.append(fileData.name, fileData, fileData.name);
                    return ContentServerClient.upload3DModelData(handleError, newId, formData)
                            .then(() => { return { name: assetName, id: newId } })
                })
                .catch(error => assetName)

    }

    getStatusModel(handleError, id, name, timer, onProgress){
        return new Promise((resolve, reject) => this.getAssetImportStatusModel(handleError, resolve, reject, id, name, timer, onProgress));
    }

    pollImportStatusModel(handleError, resolve, reject, id, name, timer, onProgress, status) {
        timer.timeout = setTimeout(() => this.getAssetImportStatusModel(handleError, resolve, reject, id, name, timer, onProgress, status), 10000);
    }
    
    //
    getStatusOfTypeWithDelay(type, id, name, handleError, status, index){
      if(status[index] == 'complete') return Promise.resolve();
      if(type == 'step') type = 'model';
      return new Promise((resolve, reject)=>{
        setTimeout(()=>{
          ContentServerClient.getModelStatus(handleError, id, type)
              .then(info => {
                console.log(type, info.status);
                if(info.status == 'failed' || info.fail_cause) reject("step tranlation failed for "+name)
                else status[index] = info.status; 
                resolve(info);
              }).catch(reject)
        }, 10000 + Math.random()*200);
      })
    }

    // THIS WILL POLL UNTIL COMPLETE OR FAILED
    getAssetImportStatusModel(handleError, resolve, reject, id, name, timer, onProgress, status) {
        if(!status) status = ['translating', 'translating', 'translating'];
        
        return this.getStatusOfTypeWithDelay('f3d', id, name, handleError, status, 0)
        .then(()=> this.getStatusOfTypeWithDelay('step', id, name, handleError, status, 1))
        .then(()=> this.getStatusOfTypeWithDelay('obj', id, name, handleError, status, 2))
        //return this.getStatusOfTypeWithDelay('f3d', id, name, handleError, status, 0)
        .then(()=> {
          // if all got set to true, we are done polling.
            if(status.indexOf('translating') == -1){
               resolve(); 
            } else {
              this.pollImportStatusModel(handleError, resolve, reject, id, name, timer, onProgress, status)
            }
        })
        .catch(err =>{
          reject();
        })
    }

    validateUrl(url){
        if(url == '') return false;

        if(!url.match(/^https?:\/\//i)){
            return false;
        }
        return true
    }

    validateFile(file, expression = /.*\.(lbr|intlib|pcblib|schlib|olb)$/i){
        var patt = new RegExp(expression);
        if (patt.test(file.name)) {
            return true
        }
        return false;
    }
}

module.exports = new ImportUtil();
